export enum BoolEnum {
    YES = 'true',
    NO = 'false'
}